var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterSolidinline = function SvgFilterSolidinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a1 1 0 0 0-2 0v4h2V2Zm0 12V7H7v7a1 1 0 1 0 2 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2h4Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2a1 1 0 1 0-2 0v9h2V2Zm0 12v-2h-2v2a1 1 0 1 0 2 0Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2a1 1 0 0 0-2 0v10h2V2Zm0 12v-1H2v1a1 1 0 1 0 2 0Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2H1Z",
    fill: "#fff"
  })));
};
export default SvgFilterSolidinline;